import api from "./api";

export const CHUNK_BYTES = 512 * 1024;

// Downscale JPG/PNG/WebP in the browser (max 1600px, JPEG q0.85). HEIC and failures fall back to the original file.
export const compressImage = (file) =>
  new Promise((resolve) => {
    if (!/^image\/(jpeg|png|webp)$/.test(file.type)) return resolve(file);
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      const scale = Math.min(1, 1600 / Math.max(img.width, img.height));
      if (scale === 1 && file.size < 900 * 1024) return resolve(file);
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob((blob) => resolve(blob ? new File([blob], file.name.replace(/\.\w+$/, "") + ".jpg", { type: "image/jpeg" }) : file), "image/jpeg", 0.85);
    };
    img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
    img.src = url;
  });

// Chunked upload: start -> PUT chunks -> returns upload_id for the attach call.
export const uploadInChunks = async (file, onProgress) => {
  const type = file.type || (/\.hei[cf]$/i.test(file.name) ? "image/heic" : "application/octet-stream");
  const start = await api.post("/uploads/start", { filename: file.name, content_type: type, size: file.size });
  const { upload_id: id, chunk_bytes: size = CHUNK_BYTES } = start.data;
  const total = Math.ceil(file.size / size);
  for (let i = 0; i < total; i += 1) {
    const chunk = file.slice(i * size, (i + 1) * size);
    await api.put(`/uploads/${id}/chunks/${i}`, chunk, { headers: { "Content-Type": "application/octet-stream" } });
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  return id;
};
